<template>
  <div class="w-full flex p-2 grow pt-0 min-h-[20em] flex-col">
    <div class="shrink-0 mb-2 flex items-center space-x-2">
      <button
        type="button"
        class="duration-200 bg-gray-200 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        :class="rawHtml && '!bg-primary'"

        role="switch"
        aria-checked="false"

        @click="rawHtml = !rawHtml"
      >
        <span class="sr-only">Use setting</span>
        <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
        <span
          aria-hidden="true"
          class="translate-x-0 duration-200 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
          :class="rawHtml && '!translate-x-5'"
        ></span>
      </button>
      <span>Write raw HTML</span>
    </div>

    <div class="grow relative w-full">
      <div class="absolute w-full h-full box-border">
        <div class="w-full h-full bg-[#1e293b] rounded grow relative">
          <RawHtml v-if="rawHtml" v-bind="$props" @save="save"/>
          <RichText v-else v-bind="$props" @save="save"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import RawHtml from "@/components/SideEditor/BlockConfigurationTabs/CmsRichTextEditor/RawHtml"
import RichText from "@/components/SideEditor/BlockConfigurationTabs/CmsRichTextEditor/RichText"

export default {
  components: {
    RawHtml,
    RichText,
  },
  props: ['id', 'title', 'role', 'config', 'content'],
  data() {
    return {
      rawHtml: false,
    }
  },
  methods: {
    save(rich_text) {
      this.$store.dispatch("editor/overwriteBlock", {
        role: this.role, id: this.id,
        block: {
          content: { rich_text }
        }
      })
    },
  },
}

</script>

